var _style, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoticeboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:currentColor;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.18,4.47c0.34,0.6,0.69,1.13,0.93,1.71c0.08,0.19-0.07,0.58-0.25,0.76c-3.27,3.29-6.56,6.55-9.84,9.83 c-0.26,0.26-0.5,0.55-0.9,0.98c9.77,0,19.31,0,28.61,0c-3.52-3.58-7.16-7.3-10.79-10.99c0.47-0.87,0.83-1.56,1.33-2.48 c1.77,1.83,3.46,3.61,5.18,5.35c2.54,2.56,5.1,5.11,7.69,7.63c0.32,0.31,0.87,0.54,1.32,0.55c2.91,0.05,5.83,0.02,8.74,0.03 c1.82,0.01,2.61,0.82,2.61,2.65c0,13.51-0.02,27.02,0.02,40.54c0.01,1.76-1.02,2.78-2.69,2.78c-18.38-0.06-36.76-0.03-55.14-0.03 c-1.66,0-2.49-0.81-2.49-2.47c0-13.67,0-27.34,0.01-41.02c0-1.55,0.86-2.44,2.43-2.45c2.88-0.02,5.76-0.04,8.64,0.01 c0.78,0.01,1.31-0.24,1.84-0.78c4.09-4.09,8.19-8.17,12.3-12.24C26.87,4.7,27.02,4.6,27.18,4.47z M57.4,22.18 c-17.17,0-34.28,0-51.43,0c0,12.46,0,24.85,0,37.25c17.19,0,34.3,0,51.43,0C57.4,46.98,57.4,34.6,57.4,22.18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.66,3.48c-0.02-1.68,1.36-3.09,3.02-3.08c1.68,0.01,3.04,1.37,3.04,3.06c0,1.64-1.4,2.99-3.11,3 C30.1,6.46,28.67,5.02,28.66,3.48z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.58,34.98c-5.82,0-11.65,0.01-17.47-0.02c-0.45,0-1-0.11-1.32-0.38c-0.28-0.24-0.49-0.82-0.4-1.17 c0.1-0.38,0.52-0.76,0.9-0.96c0.34-0.18,0.81-0.14,1.22-0.14c11.39-0.01,22.79,0,34.18,0c0.26,0,0.51-0.01,0.77,0 c1.02,0.04,1.63,0.57,1.6,1.39c-0.03,0.78-0.63,1.26-1.61,1.26C43.49,34.98,37.53,34.98,31.58,34.98z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.68,50.75c-5.99,0-11.97-0.01-17.96,0.01c-0.61,0-1.13-0.18-1.27-0.75c-0.1-0.41,0-0.94,0.19-1.32 c0.11-0.23,0.55-0.4,0.86-0.43c0.6-0.07,1.21-0.02,1.82-0.02c11.4,0,22.79,0,34.19,0c0.96,0,1.54,0.5,1.55,1.31 c0.01,0.74-0.57,1.22-1.52,1.23C43.59,50.76,37.64,50.76,31.68,50.75C31.68,50.76,31.68,50.75,31.68,50.75z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.59,42.88c-1.89,0-3.77,0.01-5.66,0c-1.13-0.01-1.63-0.42-1.64-1.3c-0.01-0.86,0.52-1.31,1.63-1.32 c3.8-0.01,7.61-0.01,11.41,0c1.1,0,1.74,0.54,1.71,1.36c-0.03,0.83-0.6,1.25-1.7,1.25C47.43,42.88,45.51,42.88,43.59,42.88z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.72,40.29c1.95,0,3.9-0.02,5.86,0.01c1.04,0.02,1.48,0.43,1.49,1.23c0.01,0.87-0.49,1.34-1.5,1.34 c-3.94,0.01-7.87,0-11.81,0c-0.64,0-1.22-0.2-1.33-0.84c-0.07-0.44,0.08-0.99,0.32-1.37c0.15-0.24,0.66-0.34,1.01-0.34 C15.76,40.28,17.74,40.29,19.72,40.29z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeboard);
export default __webpack_public_path__ + "static/media/noticeboard.2b7f0442d0f4ae71c0cb8cd0771425b3.svg";
export { ForwardRef as ReactComponent };